
jQuery (function () {
    function initCartQuantityInputs () {
        jQuery ('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.woocommerce-cart-form .quantity input');

        jQuery ('.woocommerce-cart-form .quantity').each (function () {

            var spinner = jQuery (this),
                input   = spinner.find ('input[type="number"]'),
                btnUp   = spinner.find ('.quantity-up'),
                btnDown = spinner.find ('.quantity-down'),
                min     = 0;
                // max     = input.attr ('max');

            btnUp.click (function () {
                var oldValue = parseFloat (input.val ());
                
                // if (oldValue >= max) { 
                //     var newVal = oldValue;
                // } else {
                //     var newVal = oldValue + 1;
                // }

                var newVal = oldValue + 1;

                spinner.find ("input").val (newVal);
                spinner.find ("input").trigger ("change");
            });

            btnDown.click (function () {
                var oldValue = parseFloat (input.val ());

                if (oldValue <= min) {
                    var newVal = oldValue;
                } else {
                    var newVal = oldValue - 1;
                }
                
                var newVal = oldValue - 1;

                spinner.find ("input").val (newVal);
                spinner.find ("input").trigger ("change");
            });
        });
    }

    initCartQuantityInputs ();

    // re-init quty items and update num items in upper right cart icon after cart update
    jQuery (document.body).on ('updated_cart_totals', function () {
        initCartQuantityInputs ();

        var numItems = 0;

        jQuery ('.woocommerce-cart-form .quantity input').each (function () {
            numItems += parseInt (jQuery (this).val (), 10);
        });

        jQuery ('.cart-num-items').text (numItems);
    });
});